import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card no-gutter orders" }
const _hoisted_2 = { class: "p-mb-4" }

import { defineComponent, onMounted, watch } from "vue";
import { useMonthlyIncome } from "@/graphql/dashboard/revenue.chart";
import { activeActivity } from "@/plugins/i18n";
import { numberSeparators } from "@/graphql/utils/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'RevenueChart',
  props: {
    year: {}
  },
  setup(__props: any) {

const props = __props;
const { loading, chartData, initChart, options } = useMonthlyIncome(props.year);

watch(
  () => props.year,
  (year) => {
    initChart(year);
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("dashboard.monthlyIncome")), 1),
    _createVNode(_component_Chart, {
      ref: "chart",
      type: "line",
      data: _unref(chartData),
      options: _unref(options),
      style: {"width":"100%"},
      height: 185
    }, null, 8, ["data", "options"])
  ]))
}
}

})